// tanstack
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/$accountId/_admin/operations/')({
  component: Outlet,
  staticData: { crumb: 'glossary:operation' },
});
